(() => {
  // Ajusta si quieres que solo pase en móvil
  const ONLY_MOBILE = true;
  const MOBILE_MAX = 990; // px

  // Espera un pelín para que el tema actualice la imagen antes de scrollear
  const SCROLL_DELAY_MS = 120;

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function findProductRoot(el) {
    return el.closest('[data-product-root], product-information, .product-information, .product') || document;
  }

  function findGallery(root) {
    // Probamos selectores típicos en temas modernos (incl. Horizon-like)
    return (
      root.querySelector('product-media-gallery') ||
      root.querySelector('.product-media') ||
      root.querySelector('.product__media') ||
      root.querySelector('[data-testid="product-media"]') ||
      root.querySelector('[data-product-media]') ||
      root.querySelector('.media-gallery') ||
      root.querySelector('.product-gallery') ||
      null
    );
  }

  let t;
  function scheduleScroll(target) {
    clearTimeout(t);
    t = setTimeout(() => {
      const root = findProductRoot(target);
      const gallery = findGallery(root);
      if (!gallery) return;

      gallery.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }, SCROLL_DELAY_MS);
  }

  // 1) Cambios en inputs/selects (botones, selects, radios…)
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el) return;

    if (ONLY_MOBILE && !isMobile()) return;

    // Detecta cambios típicos de opciones/variante
    const isOption =
      el.matches('select[name^="options"], select[name*="options["]') ||
      el.matches('input[type="radio"][name^="options"], input[type="radio"][name*="options["]') ||
      el.matches('input[type="radio"][name^="option"], input[type="radio"][name*="option"]') ||
      el.closest('variant-picker');

    if (!isOption) return;

    scheduleScroll(el);
  });

  // 2) Por si el tema dispara un evento custom (muchos lo hacen)
  //    Cubrimos varios nombres comunes.
  ['variant:change', 'variant-change', 'variantChange'].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      if (ONLY_MOBILE && !isMobile()) return;
      const target = e.target || document.querySelector('variant-picker') || document.body;
      scheduleScroll(target);
    });
  });
})();
